/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { matchRoute } from 'fierry/util/route';

import Record from 'fierry/rpc/ingest/record';
import Table from 'fierry/rpc/ingest/table';


export default class Routes
{
  constructor ()
  {
    this.routes = new Map();
    this.detaches = new Map();
  }


  createRecord (path, config)
  {
    this.createRoute(new Record(path, config));
  }


  createTable (path, config)
  {
    this.createRoute(new Table(path, config));
  }


  createRoute (route)
  {
    route.index = this.routes.size;

    this.routes.set(route.path, route);
  }


  createDetach (path, detach)
  {
    this.detaches.set(path, detach);
  }


  detach (application, routing)
  {
    const { type, args } = matchRoute(routing.join('/'), [ ...this.detaches.keys() ]);

    this.detaches.get(type)(application, args);
  }


  match (routing)
  {
    const { type, args } = matchRoute(this.getPath(routing), [ ...this.routes.keys() ]);

    return { route: this.routes.get(type), args, verb: this.getVerb(routing) };
  }


  getPath (routing)
  {
    return routing.slice(0, -1).join('/');
  }


  getVerb (routing)
  {
    return routing[routing.length - 1];
  }


};
